module.exports = __webpack_public_path__ + "img/整蛊头像框.0351ba9b.png";